<template>
  <div class="app-container">
    <el-card>
      <div slot="header" class="clearfix">
        <span>订单列表</span>
      </div>
      
      <!-- 搜索区域 -->
      <el-form :inline="true" :model="queryParams" class="demo-form-inline">
        <el-form-item label="订单号">
          <el-input v-model="queryParams.orderNo" placeholder="请输入订单号" clearable />
        </el-form-item>
        <el-form-item label="用户手机号">
          <el-input v-model="queryParams.userPhone" placeholder="请输入手机号" clearable />
        </el-form-item>
        <el-form-item label="订单状态">
          <el-select v-model="queryParams.orderStatus" placeholder="请选择状态" clearable>
            <el-option label="待支付" :value="0" />
            <el-option label="已支付" :value="1" />
            <el-option label="配送中" :value="2" />
            <el-option label="已完成" :value="3" />
            <el-option label="已取消" :value="4" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- 数据表格 -->
      <el-table v-loading="loading" :data="orderList">
        <el-table-column label="订单ID" align="center" prop="id" width="80" />
        <el-table-column label="订单号" align="center" prop="orderNo" width="180" />
        <el-table-column label="用户信息" align="center" prop="userName" width="120" />
        <el-table-column label="订单金额" align="center" prop="totalAmount" width="120" />
        <el-table-column label="订单状态" align="center" prop="orderStatus" width="100">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.orderStatus)">
              {{ getStatusText(scope.row.orderStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="支付方式" align="center" prop="payType" width="100" />
        <el-table-column label="下单时间" align="center" prop="createTime" width="180" />
        <el-table-column label="操作" align="center" width="250" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="text" icon="el-icon-view" @click="handleView(scope.row)">详情</el-button>
            <el-button size="mini" type="text" icon="el-icon-edit" @click="handleUpdate(scope.row)">处理</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      />
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'OrderList',
  data() {
    return {
      loading: true,
      total: 0,
      orderList: [],
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        orderNo: undefined,
        userPhone: undefined,
        orderStatus: undefined
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      // TODO: 调用API获取订单列表
      setTimeout(() => {
        this.orderList = []
        this.total = 0
        this.loading = false
      }, 500)
    },
    handleQuery() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.resetForm('queryForm')
      this.handleQuery()
    },
    getStatusType(status) {
      const types = { 0: 'warning', 1: 'success', 2: 'primary', 3: 'info', 4: 'danger' }
      return types[status] || ''
    },
    getStatusText(status) {
      const texts = { 0: '待支付', 1: '已支付', 2: '配送中', 3: '已完成', 4: '已取消' }
      return texts[status] || '未知'
    },
    handleView(row) {
      this.$message.info('查看详情功能待实现')
    },
    handleUpdate(row) {
      this.$message.info('订单处理功能待实现')
    }
  }
}
</script>

<style scoped>
.app-container {
  padding: 20px;
}
</style>
